var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('v-switch',{attrs:{"value":_vm.bizservice?.third_party?.merge_menu,"label":"Combine Menus","hint":_vm.hint,"persistent-hint":"","loading":_vm.loading},on:{"change":_vm.toggle}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }